/* src/app/components/payroll/timesheets/timesheet-detail-component/timesheet-detail.component.css */
/*# sourceMappingURL=timesheet-detail.component-NZKHRYJN.css.map */
